<template>
    <div class="interval">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <div class="right searchBtn">
                            <button type="button" @click="clear"><i class="el-icon-plus"></i>添加时段</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable jobTitleTable">
                            <tr>
                                <th style="width:20%" class="left1">名称</th>
                                <th style="width:65%">时间</th>
                                <th style="width:15%">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable jobConTable" :class="{overLengthTable:jobsList.length>pageSize}">
                                    <tr v-for="item in jobsList">
                                        <td style="width:20%" class="left1" v-text="item.name"></td>
                                        <td style="width:65%" v-text="item.time">
                                        </td>
                                        <td style="width:15%">
                                            <div v-if="item.id" class="btnInline">
                                                <span title="修改" @click="getCurJob(item)"><i class="iconfont icon-bianji"></i></span>
                                                <span title="删除" @click="delJob(item.id)"><i class="iconfont icon-icon1460188478041"></i></span>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            :title="curJobId?'修改时段':'添加时段'"
            :visible.sync="addJobVisible"
            size="tiny">
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>名称</span>
                        <input type="text" class="left itemInput" v-model="timeName" placeholder="请输入时段名称">
                    </div>
                    <div class="left msgItem clearfix groupRoles">
                        <span class="left itemName permissions"><i>*</i>开始时间</span>
                        <div class="left">
                            <div class="rowItem">
                                <el-input
                                    style="width:80px"
                                  placeholder="请输入时"
                                  v-model="time.beginHour"
                                  clearable>
                                </el-input>
                                <span style="color:red;">时</span>
                                <el-input
                                    style="width:80px"
                                   placeholder="请输入分"
                                  v-model="time.beginMinute"
                                  clearable>
                                </el-input>
                                <span style="color:red;">分</span>
                            </div>
                        </div>
                    </div>
                    <div class="left msgItem clearfix groupRoles" style="margin-top:20px;">
                        <span class="left itemName permissions"><i>*</i>结束时间</span>
                        <div class="left">
                                <div class="rowItem">
                                    <el-input
                                        style="width:80px"
                                        placeholder="请输入时"
                                        v-model="time.endHour"
                                        clearable>
                                    </el-input>
                                    <span style="color:red;">时</span>
                                    <el-input
                                        style="width:80px"
                                      placeholder="请输入分"
                                      v-model="time.endMinute"
                                      clearable>
                                    </el-input>
                                    <span style="color:red;">分</span>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addJobVisible=false" class="cancel">取消</button>
                <button type="button" @click="addJob" class="save">保存</button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    export default{
        props: ['curStoreId','pageSize'],
        data () {
            return {
                jobsList: [], // 岗位列表
                timeName:'',
                curJobId: '', // 时段id
                addJobVisible: false, // 控制新增弹框显示隐藏
                addJobApiBtn: true, // 控制新增岗位接口
                time:{
                    beginHour:'',
                    beginMinute:'',
                    endHour:'',
                    endMinute:''
                }
            }
        },
        watch:{
          
        },
        methods: {
            // 获取岗位列表
            getJobsList: function () {
                this.$http.get('/product-supply-time?storeId='+this.curStoreId).then((res)=>{
                    this.jobsList = res.data;
                    for (let i = 0; i <  this.jobsList.length; i++) {
                        if(this.jobsList[i].id){
                            this.jobsList[i].time = (this.jobsList[i].beginHour<10?'0'+this.jobsList[i].beginHour:this.jobsList[i].beginHour)+':'
                            +(this.jobsList[i].beginMinute<10?'0'+this.jobsList[i].beginMinute:this.jobsList[i].beginMinute)+'~'
                            +(this.jobsList[i].endHour<10?'0'+this.jobsList[i].endHour:this.jobsList[i].endHour)+':'
                            +(this.jobsList[i].endMinute<10?'0'+this.jobsList[i].endMinute:this.jobsList[i].endMinute)
                        }
                    }
                    let number = this.pageSize - this.jobsList.length;
                    if ( number > 0 ) {
                        for (let i = 0; i < number; i++) {
                            this.jobsList.push({
                                name:''
                            });
                        }
                    }
                }).catch((err)=>{

                })
            },
            // 新增, 更新岗位
            addJob: function () {
                if(!this.timeName){
                    this.$message({
                        message: '请输入时段名',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.time.beginHour.length>2||parseInt(this.time.beginHour)>23||!/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.beginHour))){
                    this.$message({
                        message: '开始小时数设置有误',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.time.beginMinute.length>2||!/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.beginMinute))||parseInt(this.time.beginMinute)>59){
                    this.$message({
                        message: '开始分钟数设置有误',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.time.endHour.length>2||!/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.endHour))||parseInt(this.time.endHour)>23){
                    this.$message({
                        message: '结束小时数设置有误',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.time.endMinute.length>2||!/^(0|[1-9][0-9]*)$/.test(parseInt(this.time.endMinute))||parseInt(this.time.endMinute)>59){
                    this.$message({
                        message: '结束分钟数设置有误',
                        customClass: 'error'
                    })
                    return;
                }
                if ( !this.addJobApiBtn ) {
                    return;
                }
                this.addJobApiBtn = false;
                let body = {
                    id:this.curJobId?this.curJobId:this.$uuid.create(1).hex,
                    storeId:this.curStoreId,
                    name:this.timeName,
                    beginHour:parseInt(this.time.beginHour),
                    beginMinute:parseInt(this.time.beginMinute),
                    endHour:parseInt(this.time.endHour),
                    endMinute:parseInt(this.time.endMinute)
                }
                this.$http.post('/product-supply-time',body).then((res)=>{
                    this.addJobVisible = false;
                    this.addJobApiBtn = true;
                    this.getJobsList();
                    this.$message({
                        message: '操作成功',
                        customClass: 'success'
                    })
                }).catch((err)=>{
                    this.addJobApiBtn = true;
                })
            },
            // 删除岗位
            delJob: function ( jobId ) {
                this.$confirm('此操作将删除该时段, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    //删除岗位
                    this.$http.delete('/product-supply-time?id='+jobId).then((res)=>{
                        this.$message({
                            message: '删除成功',
                            customClass: 'success'
                        })
                        this.getJobsList();
                    }).catch((err)=>{
                        
                    })
                }).catch(() => {});
            },
            // 获得当前岗位信息
            getCurJob: function ( item ) {
                this.curJobId = item.id;
                this.timeName = item.name;
                this.time = {
                    beginHour:item.beginHour,
                    beginMinute:item.beginMinute,
                    endHour:item.endHour,
                    endMinute:item.endMinute
                }
                this.addJobVisible = true;
            },
            // 清除信息
            clear: function () {
                this.timeName = '';
                this.time = {
                    beginHour:'',
                    beginMinute:'',
                    endHour:'',
                    endMinute:''
                }
                this.checkedCities = [];
                this.curJobId = '';
                this.addJobVisible = true;
            }
        },
        created: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.jobsList.push({
                    name:''
                });
            }
        },
        activated: function () {
            this.getJobsList();
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
    @import "interval";
</style>



// WEBPACK FOOTER //
// interval.vue?eae2623e